import {
  FORCE_PAGES_TO_KEEP_FOR_CHATBOT,
  PAGES_TO_EXCLUDE_FOR_CHATBOT,
  PAGES_TO_EXCLUDE_FOR_CHATBOT_ON_MOBILE_ONLY,
} from '@constants/chatbot';
import useI18n from '@hooks/i18n/useI18n';
import { useMediaQuery } from '@monofront/business/hooks';
import { isMobileApp } from '@utils/environment';
import { useRouter } from 'next/router';
import useIsCobbaiEnabled from './useIsCobbaiEnabled';

const useIsBotmindEnabled = (): boolean => {
  const { isFrenchMarket } = useI18n();
  const isMobileWebsite = useMediaQuery(800);
  const router = useRouter();
  const isCobbaiEnabled = useIsCobbaiEnabled();

  // If I put /pages/[handle] in PAGES_TO_EXCLUDE_FOR_CHATBOT, It will hide botmind for all pages.
  // Here we need to exclude botmind only in /pages/paiement and keep botmind in all other pages. same for /account/[handle]
  const hideBotmind =
    (!FORCE_PAGES_TO_KEEP_FOR_CHATBOT.includes(router.asPath) &&
      PAGES_TO_EXCLUDE_FOR_CHATBOT.includes(router.pathname)) ||
    PAGES_TO_EXCLUDE_FOR_CHATBOT.includes(router.asPath) ||
    (isMobileWebsite &&
      PAGES_TO_EXCLUDE_FOR_CHATBOT_ON_MOBILE_ONLY.includes(router.pathname));

  // Cobbai is the intended replacement for Botmind — when its flag is on, it takes over.
  return isFrenchMarket && !isMobileApp && !hideBotmind && !isCobbaiEnabled;
};

export default useIsBotmindEnabled;
